import { Component, OnInit, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'tp-control-wrapper',
  templateUrl: './control-wrapper.component.html',
  styleUrls: ['./control-wrapper.component.scss']
})
export class ControlWrapperComponent implements OnInit {
  @Input() label: string;
  @Input() isLabelHidden: boolean;
  @Input() showErrors: boolean;
  @Input() isInvert = false;
  @Input() fieldErrors: ValidationErrors;
  @Input() errorMappingKey: string;
  @Input() labelIcon: string;
  @Input() asterisk: boolean;
  @Input() tooltipText: boolean;
  @Input() infoMsg: string;
  @Input() showInfoMsg: boolean;
  @Input() labelFor: string;

  constructor() {}

  ngOnInit(): void {}
}
